import React, {FC} from 'react'
import {UseFormRegister, FieldErrors, Controller, useFormContext} from 'react-hook-form'
type InputProps = {
  name: string
  register: UseFormRegister<any>
  errors: FieldErrors
  minValue?: string
  disabled?: boolean
  customOnChangeFunction?: (e: any) => void
}

const InputDateForm: FC<InputProps> = ({
  name,
  register,
  errors,
  minValue = '1999-01-01',
  disabled = false,
  customOnChangeFunction,
  ...props
}) => {
  const {control} = useFormContext()

  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <input
            type='Date'
            className='form-control sdx-centra-input-form'
            min={minValue}
            max={'3999-01-01'}
            disabled={disabled}
            {...field}
          />
        )}
      />

      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputDateForm
